import React, { PropsWithChildren } from 'react'
import Frame from './Frame'
import CRTScreen from './CRTScreen'

type Props = PropsWithChildren<{
}>

const Display: React.FC<Props> = ({ children }) => {
  return (
    <Frame>
      <CRTScreen>
          {children}
      </CRTScreen>
    </Frame>
  ) 
}

export default Display
